import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import HelpSupportViewPage from "../../components/HelpAndSupport/HelpSupportViewPage";

const ViewHelpAndSupportPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb
          id="title"
          title2="Help And Supports"
          link2="/help-supports"
          title="View Help And Support"
        />

        <HelpSupportViewPage/>
      </MasterLayout>
    </>
  );
};

export default ViewHelpAndSupportPage;
